module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-left-teal-17e02254cbfb023041cbc0c9d5e8d3a5.svg";